import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import TopNavbar from "../Nav/TopNavbar";
import Footer from "./Footer";
import axios from "axios";
import { makePostRequest } from "../../services/httpHelper";
import ErrorHandler from "../../services/ErrorHandler";

export default function PaymentPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const order = location.state?.order;
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [serverError,setServerError] = useState(null);

  

  useEffect(() => {
    if (!order) {
      return navigate("/checkout");
    }

    if (order.plan === "trial") {
      handleTrialFlow();
    }
  }, [order]);

  const handleTrialFlow = async () => {
    setLoading(true);
    try {
        const res = await makePostRequest('licenses/trial',{
        customer_id: order.customerId,
        edition: order.product,
        plan:order.plan
      });
            if (res && res.errorType) {

              
                setIsSubmitting(false);
                const errorMessage = ErrorHandler(res)
                console.log(errorMessage)
                setServerError(`Server or Network error occured.${errorMessage?.data}`)
      
            } else {
                navigate("/trial-thank-page", {
          state: { download_url: res.data.download_url },
        });
          
          }
      
    } catch (err) {
      setMessage("Failed to process trial. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handlePayment = (method) => {
    // real payment implementation will go here
    console.log("Processing payment with method:", method);
    if(method==='mpesa'){
      navigate(`/checkout/mpesa`,{state:order})
    }else{
      navigate(`/payment-options`,{state:order})
    }
  };

  if (!order || order.plan === "trial") {
    return (
      <>
        <TopNavbar returnTo={true} />
        <Wrapper>
          <h2>Processing Trial...</h2>
          <p>{loading ? "Setting up your trial license..." : message}</p>
        </Wrapper>
        <Footer />
      </>
    );
  }

  return (
    <>
      <TopNavbar returnTo={true} />
      <Wrapper>
        <h2>Review & Confirm Your Payment</h2>
        <OrderSummary>
          <p><strong>Customer:</strong> {order.customer}</p>
          <p><strong>Product:</strong> {order.product}</p>
          <p><strong>Plan:</strong> {order.plan}</p>
          <p><strong>Total:</strong> KES {order.price}</p>
        </OrderSummary>
        <PaymentOptions>
          <h3>Choose Payment Method</h3>
          <button onClick={() => handlePayment("mpesa")} style={{backgroundColor:"green"}}>Pay with MPESA</button>
          <button onClick={() => handlePayment("card")}>Pay with Card/Airtel Money/Mpesa Till</button>
          {/*<button onClick={() => handlePayment("bank")}>Pay via Bank</button>*/}
        </PaymentOptions>
      </Wrapper>
      <Footer />
    </>
  );
}

const Wrapper = styled.div`
  max-width: 600px;
  margin: 60px auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 12px;
  h2 {
    text-align: center;
    margin-bottom: 20px;
  }
`;

const OrderSummary = styled.div`
  margin-bottom: 30px;
  p {
    margin: 5px 0;
  }
`;

const PaymentOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  button {
    padding: 12px;
    border: none;
    background: purple;
    color: white;
    border-radius: 6px;
    cursor: pointer;
    &:hover {
      background: #5e2a84;
    }
  }
`;
